import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton } from "react-share";

function news({ news }) {
  const shareUrl = "www.finnovex.com/finnovexlive/";
  return (
    <>
      <Container>
        <Row className="py-4">
          <Col lg={6}>
            <div className="owner">
              <div className="avatar-big text-center">
                <img
                  alt=""
                  className="img-no-padding img-responsive img-rounded pt-2"
                  src={require(`assets/images/news/${news.image}`)}
                  width={"400px"}
                />
              </div>
            </div>
          </Col>
          <Col lg={6} className="align-self-center mt-3 text-white"></Col>
        </Row>

        <Row>
          <Col xs={1} className="d-none d-xl-block d-lg-block d-md-block"></Col>
          <FacebookShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                  marginLeft: "15px",
                }}
              >
                <span style={{ color: "#3b5998", display: "inline" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-facebook-square float-left" />
                </span>
              </Button>
            }
          />

          <LinkedinShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                color="neutral"
                outline
                style={{
                  padding: "0rem",
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#0976b4" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-linkedin-square float-left" />
                </span>
              </Button>
            }
          />
          <TwitterShareButton
            url={`${shareUrl}${news.link}`}
            style={{ padding: 0, margin: 0, display: "inline !important" }}
            children={
              <Button
                outline
                style={{
                  padding: 0,
                  borderColor: "#000",
                  marginRight: "30px",
                }}
              >
                <span style={{ color: "#55acee" }}>
                  <i style={{ fontSize: "50px" }} className="fa fa-twitter-square float-left" />
                </span>
              </Button>
            }
          />
        </Row>

        <Row>
          <Col className={"ml-auto mr-auto text-justify"} md="10">
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-You’ve led major transformations, from digital bank launches to core banking
                replacements—what’s the key to executing these large-scale initiatives successfully
                across multiple jurisdictions and regulatory environments?
              </strong>
            </h5>

            <h5 className="text-white">
              Success in large- scale transformation depends on early alignment between strategy,
              regulation and execution. Each jurisdiction brings unique regulatory and operational
              complexities and the key to strategic execution is strong planning, clear
              communication, and flexibility. Success depends on working closely with local and
              international teams and having the right talent and technology in place to ensure
              scalability and control throughout the journey.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-With your deep expertise in enterprise data and analytics, how do you envision the
                role of real-time intelligence in reshaping operational decision-making and customer
                engagement within modern banking?
              </strong>
            </h5>
            <h5 className="text-white">
              Real-time intelligence plays a central role in helping banks be more proactive than
              reactive. By leveraging real-time data, we can enhance decision making at every level
              - for example, we can tailor products to individual needs, identify risks early, and
              improve operation responsiveness. It also helps us reduce delays, optimize costs and
              respond effectively to market changes. In a fast-moving digital environment, this
              agility is essential for both competitiveness and customer satisfaction.
            </h5>
            <br />
            <h5 className="text-white">
              <strong>
                Q-Having overseen complex mergers and acquisitions, what are the most overlooked
                integration challenges that banks face post-merger, particularly from an operational
                and technology standpoint?
              </strong>
            </h5>
            <h5 className="text-white">
              One of the most underestimated challenges is the integration of systems, processes and
              cultures. Many forget that merging teams, systems, and data takes time and care. Even
              if the business deal is done, combining operations and technology can be complex and,
              without full alignment, the value of the merger can be delayed. Additionally, employee
              engagement and clear communication, which tend to be overlooked post-merger, are
              essential to ensure a smooth transition and sustainable integration.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-As someone who has delivered automated regulatory reporting frameworks, how do you
                balance the demand for compliance efficiency with the growing pressure for agility
                and innovation in operations?
              </strong>
            </h5>
            <h5 className="text-white">
              Embedding compliance into the innovation process is essential. We need to use
              automation, AI and smart centralized data platforms to meet regulatory requirements
              efficiently. This approach reduces manual effort, increases accuracy and accelerates
              the speed of transformation across the organization - remaining fully compliant. When
              compliance is part of the system, not added later, we can move faster while staying
              safe and meeting all requirements.
            </h5>
            <br />
            <br />
            <h5 className="text-white">
              <strong>
                Q-Given your leadership experience in both the GCC and Levant regions, how do market
                maturity and customer expectations differ, and how should banks tailor their
                transformation strategies accordingly?
              </strong>
            </h5>
            <h5 className="text-white">
              In the GCC, markets are typically more digitally mature, and customers expect speed,
              convenience and integrated digital experiences. Whereas in the Levant, people often
              have more traditional banking expectations, prioritizing stability and trust and
              looking for more personalized service and security. An effective transformation
              strategy must be tailored in each market – driving innovation in digitally mature
              markets, whereas focusing on digital inclusion and trust building where adoption is
              still evolving. Customization is essential to achieving impactful results.
            </h5>
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default news;
